/**
 * SystemCommonCodeManagementPage Helpers
 * 공통코드 관리 페이지 헬퍼 함수 및 상수
 */

import { SYSTEM_STORAGE_KEYS, DASHBOARD_EVENTS, SYSTEM_TAB_IDS, USE_YN } from '../../shared/config/system.config';
import { setItem, removeItem } from '@/shared/utils/storage';

// ======== 상수 ========

/** 테이블 컬럼 헤더 */
export const GROUP_TABLE_HEADERS = ['그룹코드', '그룹명', '그룹값', '관리', ''] as const;
export const CODE_TABLE_HEADERS = ['공통코드', '공통코드명', '사용여부', '코드값1', '코드값2', '코드값3', '코드값4', '코드값5'] as const;

/** 빈 데이터 메시지 */
export const EMPTY_MESSAGES = {
    NO_GROUPS: '그룹이 없습니다.',
    NO_CODES: '공통코드가 없습니다.',
} as const;

/** 로딩 메시지 */
export const LOADING_MESSAGES = {
    GROUPS: '그룹 목록을 불러오는 중...',
    CODES: '공통코드를 불러오는 중...',
} as const;

// ======== 네비게이션 헬퍼 ========

/**
 * 공통코드 추가 페이지로 이동
 */
export const navigateToAddPage = (): void => {
    removeItem(SYSTEM_STORAGE_KEYS.COMMON_CODE_EDIT_MODE);
    window.dispatchEvent(new CustomEvent(DASHBOARD_EVENTS.NAVIGATE, {
        detail: { page: SYSTEM_TAB_IDS.COMMON_CODE_ADD }
    }));
};

/**
 * 공통코드 수정 페이지로 이동
 * @param grpCode 수정할 그룹코드
 */
export const navigateToEditPage = (grpCode: string): void => {
    setItem(SYSTEM_STORAGE_KEYS.COMMON_CODE_EDIT_GRP_CODE, grpCode);
    setItem(SYSTEM_STORAGE_KEYS.COMMON_CODE_EDIT_MODE, 'true');
    window.dispatchEvent(new CustomEvent(DASHBOARD_EVENTS.NAVIGATE, {
        detail: { page: SYSTEM_TAB_IDS.COMMON_CODE_ADD }
    }));
};

// ======== 표시 헬퍼 ========

/**
 * 사용여부 라벨 반환
 * @param useYn 사용여부 값
 */
export const getUseYnLabel = (useYn: string): string => {
    return useYn === USE_YN.YES ? '사용' : '미사용';
};

/**
 * 사용여부 CSS 클래스 반환
 * @param useYn 사용여부 값
 */
export const getUseYnClassName = (useYn: string): string => {
    return useYn === USE_YN.YES ? 'active' : 'inactive';
};

/**
 * 값이 없으면 '-' 반환
 * @param value 표시할 값
 */
export const displayValue = (value: string | undefined | null): string => {
    return value || '-';
};
